import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { RangeInfo } from '@root/search/models/map.models';

@Component({
  selector: 'rlst-layer-legend-data',
  templateUrl: './layer-legend-data.component.html',
  styleUrls: ['./layer-legend-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class LayerLegendDataComponent {
  @Input() layerLabel: string;
  @Input() legendData: Array<RangeInfo>;
  @Output() closeLayer: EventEmitter<void> = new EventEmitter();
}
